"use client";

import { useAtomValue } from "jotai";
import React from "react";
import type { ReactElement } from "react";
import { SitesObservatoryListItem } from "@/components";
import { filteredObservatoriesAtom } from "@/store/sites";
import {
  Carousel,
  CarouselContent,
  CarouselItem,
  CarouselNext,
  CarouselPrevious,
} from "@oreme/ui";

function SitesObservatoryList(): ReactElement {
  const filteredObservatories = useAtomValue(filteredObservatoriesAtom);

  return (
    <Carousel
      className="w-full"
      opts={{
        align: "start", // Align slides to the start
        containScroll: "trimSnaps", // Prevent empty space at the end
      }}
    >
      <CarouselContent className="pl-8">
        {filteredObservatories.map((observatory) => {
          return (
            <CarouselItem key={observatory.id} className="basis-auto p-1">
              <SitesObservatoryListItem observatory={observatory} />
            </CarouselItem>
          );
        })}
      </CarouselContent>
      <CarouselPrevious style={{ top: "-20px", left: "auto", right: "48px" }} />
      <CarouselNext className="z-50" style={{ top: "-20px", right: "16px" }} />
    </Carousel>
  );
}

export { SitesObservatoryList };
